import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import 'assets/style/app/index.css';
import routes from 'routes';
import * as SRC from 'modules/styled';


const Root = ({ store }) => (
  <SRC.AppWrapper className="root">
    <Provider store={store}>
      {routes}
    </Provider>
  </SRC.AppWrapper>
);

Root.displayName = 'Root';

Root.propTypes = {
  store: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default Root;
